import {div} from '@cycle/dom';

export const wrapInDiv = (node) =>
  div(node)
;



/** WEBPACK FOOTER **
 ** ./app/lib/dom-helper.js
 **/